import { useQuery } from '@tanstack/react-query'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import config from '../../config'
import { EntityState } from '../entity-state'
import enrichInspection from './enrich-inspection'

const useInspections = ({ airportId, entityState = EntityState.Open, includeDetail = false }) => {
  const url = `${config.baseUrl}/${airportId}/Inspections?entityState=${entityState}&includeDetail=${includeDetail}`
  const request = useMemo(() => ({ method: 'get', url }), [url])
  const fetchInspections = useCallback(() => axios(request).then(res => res.data), [request])

  const {
    data,
    error,
    isLoading: loading,
    refetch,
  } = useQuery(['inspections', airportId, entityState, includeDetail], fetchInspections, {
    initialData: [],
  })

  data.forEach(inspection => enrichInspection(inspection))

  return { data, error, loading, execute: refetch }
}

export default useInspections
